/**
 * Servicios visibles en listados públicos (misma lista que en ficha de detalle).
 */

const VISIBLE_SERVICE_NAMES = new Set([
  "recobro amistoso",
  "recobro judicial",
  "defensa juridica para entidades financieras",
  "defensa juridica",
  "compra de carteras npl",
  "servicios para inversores",
  "back office juridico",
  "back office juridica",
]);

/**
 * Normaliza título o slug para comparación (sin acentos ni símbolos).
 * @param {string} value
 * @returns {string}
 */
export const normalizeServiceName = (value = "") =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

/**
 * Indica si un servicio debe mostrarse en el grid de /servicios.
 * @param {{ title?: string, seoURLFriendly?: string }} service
 * @returns {boolean}
 */
export const isVisibleListService = (service) => {
  const normalizedTitle = normalizeServiceName(service.title);
  const normalizedSlug = normalizeServiceName(service.seoURLFriendly);

  return VISIBLE_SERVICE_NAMES.has(normalizedTitle) || VISIBLE_SERVICE_NAMES.has(normalizedSlug);
};
